import isNumber from 'lodash/isnumber';
import { AccessCodes } from 'app/area/indicator-factors/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeItemCodesAccess } from 'app/area/indicator-factors/item/types';

export const mapCodeItemAccess = (codeId: number, accessCodes: AccessCodes[]): CodeItemCodesAccess => {
  const codeAccessForCodeItem = !!accessCodes
    && Array.isArray(accessCodes) && accessCodes.find(codeAccess => codeAccess.id === codeId) || {} as any;
  const { edit, move } = codeAccessForCodeItem;

  return {
    ...(isNumber(codeId) && isDefinedIncludingZero(codeId) && { id: codeId }),
    ...(edit && { edit }),
    ...(move && { move }),
    ...(codeAccessForCodeItem.delete && { delete: codeAccessForCodeItem.delete })
  };
};
